<template>
  <div class="info" v-loading="loading">
    <el-tabs v-model="activeName" type="card" class="tabs">
      <el-tab-pane label="个人信息" name="first" class="tabs-b">
        <div class="infoContent">
          <div class="infoContent-title">
            基本信息
            <div class="edit-icon" @click="editUserInfo">
              <i class="el-icon-edit"></i>
              <div class="edit-txt">编辑</div>
            </div>
          </div>
          <div
            class="infoContent-image"
            @mouseover="index = true"
            @mouseout="index = false"
            @click="dialogImgVisible = true"
          >
            <img
              v-if="userInfo.head_logo"
              :src="userInfo.head_logo"
              width="100%"
              height="100%"
              alt
            />
            <div class="infoContent-image-div"></div>
            <div class="infoContent-image-span" v-if="index == true">编辑</div>
          </div>
          <div class="adminList">
            <div>姓名：</div>
            <span>{{
              userInfo.recruit_name ? userInfo.recruit_name : "未填写"
            }}</span>
          </div>
          <div class="adminList">
            <div>招聘电话：</div>
            <span>{{ defaultPhone ? defaultPhone : "未填写" }}</span>
          </div>
          <div class="adminList">
            <div>招聘邮箱：</div>
            <span>{{ defaultEmail ? defaultEmail : "未填写" }}</span>
          </div>

          <div class="adminList">
            <div>招聘微信：</div>
            <span>{{ defaultWechat ? defaultWechat : "未填写" }}</span>
          </div>
          <div class="infoContent-tel">
            <div class="adminList">
              <div>绑定手机</div>
              <span v-if="userInfo.mobile">{{
                userInfo.mobile.replace(/^(\d{3})\d{4}(\d+)/, "$1****$2")
              }}</span>
            </div>
            <div class="infoContent-tel-mes">
              <div>
                更换绑定手机，请前往【地产同行圈】小程序，点击“我的”进行更换
              </div>
            </div>
          </div>
          <div class="adminList companyEdit">
            <div>绑定企业</div>

            <img
              :src="require('$img/jiebang.png')"
              alt
              @click="bindCompany"
              height="24px"
              width="24px"
            />
            <div class="jb-txt" @click="bindCompany">更换和解绑</div>
          </div>
          <div class="adminList companyMes">
            <img
              v-if="userInfo.company"
              :src="
                userInfo.company.logo
                  ? userInfo.company.logo
                  : require('$img/company.png')
              "
              height="46px"
              width="46px"
            />
            <img
              v-else
              :src="require('$img/company.png')"
              height="46px"
              width="46px"
            />
            <span v-if="userInfo.company">{{ userInfo.company.name }}</span>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="企业信息" name="second" class="tabs-b">
        <div>
          <enterprise-info></enterprise-info>
        </div>
      </el-tab-pane>
      <el-tab-pane label="修改密码" name="three" class="tabs-b">
        <el-form
          :model="ruleForm"
          :rules="pawwrules"
          ref="ruleForm"
          label-width="81px"
          class="enterprise-rule"
          style="margin-top: 15px"
        >
          <el-form-item label="旧密码" prop="oldpass">
            <el-input
              class="input-width"
              v-model="ruleForm.oldpass"
              show-password
              placeholder="请输入旧密码，若没有则可不填"
              :maxlength="16"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newpass">
            <el-input
              class="input-width"
              v-model="ruleForm.newpass"
              show-password
              placeholder="请输入新密码（6~16位）"
              :maxlength="16"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="cpass">
            <el-input
              class="input-width"
              v-model="ruleForm.cpass"
              show-password
              placeholder="请再次输入新密码"
              :maxlength="16"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              :loading="submitLoading"
              type="primary"
              @click="submitForm('ruleForm')"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane
        label="成员管理"
        name="four"
        v-if="
          userInfo.company && userInfo.company.company_employer.is_admin === 1
        "
      >
        <account v-if="activeName === 'four'"></account>
      </el-tab-pane>
    </el-tabs>

    <!--        个人信息弹框-->
    <el-dialog
      title="基本信息"
      :visible.sync="dialogFormVisible"
      class="adminDialog"
      v-loading="adminDialogType"
    >
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item
          v-if="userInfo.recruit_name"
          label="姓名显示："
          :label-width="formLabelWidth"
        >
          <el-radio-group v-model="radio" class="infoRadion">
            <div
              @click="choseRadio(1, userInfo.gender, userInfo.recruit_name)"
              v-if="userInfo.recruit_name"
              :class="radio == 1 ? 'infoRadionActive' : ''"
            >
              <el-radio :label="1">{{ userInfo.recruit_name }}</el-radio>
            </div>
            <div
              @click="choseRadio(2, userInfo.gender, userInfo.recruit_name)"
              v-if="userInfo.recruit_name"
              :class="radio == 2 ? 'infoRadionActive' : ''"
            >
              <el-radio :label="2" v-if="userInfo.gender == 0"
                >{{ userInfo.recruit_name.slice(0, 1) }}女士</el-radio
              >
              <el-radio :label="2" v-if="userInfo.gender == 1"
                >{{ userInfo.recruit_name.slice(0, 1) }}先生</el-radio
              >
            </div>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="招聘电话："
          :label-width="formLabelWidth"
          prop="recruit_phone"
        >
          <el-input
            class="adminInput"
            v-model="form.recruit_phone"
            autocomplete="off"
            maxlength="16"
            placeholder="请填写真实的招聘电话"
            show-word-limit
          ></el-input>
          <el-checkbox v-model="telStatus" class="adminCheck">显示</el-checkbox>
        </el-form-item>
        <el-form-item
          label="招聘微信："
          :label-width="formLabelWidth"
          prop="recruit_wechat"
        >
          <el-input
            class="adminInput"
            v-model="form.recruit_wechat"
            autocomplete="off"
            maxlength="16"
            placeholder="请填写真实的微信号"
            show-word-limit
          ></el-input>
          <el-checkbox v-model="weChatStatus" class="adminCheck"
            >显示</el-checkbox
          >
        </el-form-item>
        <el-form-item
          label="招聘邮箱："
          :label-width="formLabelWidth"
          prop="recruit_mail"
        >
          <el-input
            class="adminInput"
            v-model="form.recruit_mail"
            autocomplete="off"
            maxlength="30"
            placeholder="请填写真实的邮箱地址"
            show-word-limit
          ></el-input>
          <el-checkbox v-model="mailStatus" class="adminCheck"
            >显示</el-checkbox
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="editor('ruleForm')">保 存</el-button>
      </div>
    </el-dialog>
    <!--        上传头像-->
    <el-dialog
      title="头像上传"
      :visible.sync="dialogImgVisible"
      class="adminDialog"
    >
      <div class="infoDialogTitle">头像支持jpg、jpge、png格式，需小于2M</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogImgVisible = false">取 消</el-button>
        <el-button type="primary">上传头像</el-button>
      </div>
      <el-upload
        class="avatar-uploader"
        ref="upload"
        :action="`${httpUrl}/recruitment/file/upload`"
        :show-file-list="false"
        :on-remove="handleRemove"
        :on-success="updateSuccess"
        :before-upload="beforeAvatarUpload"
        :multiple="false"
        :data="{ type: 1 }"
        :headers="headerStr"
        :limit="1"
        name="file"
      ></el-upload>
    </el-dialog>
    <!--        企业更换弹窗-->
    <el-dialog
      title="更换企业"
      :visible.sync="dialogCompanyVisible"
      class="adminDialog"
    >
      <div class="infoDialogCompanyFirst">
        如需退出当前企业或绑定其他企业，您可先解除与当前企业的绑定。
        解除绑定后，您将：
      </div>
      <div class="infoDialogCompany">·认证取消，需重新提交企业认证</div>
      <div class="infoDialogCompany">·无法再查看当前企业的任何信息</div>
      <div class="infoDialogCompany">·在该企业相关未完结的权益将一并取消</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCompanyVisible = false">取消</el-button>
        <el-button @click="changCompany" type="primary">下一步</el-button>
      </div>
    </el-dialog>
    <!--        确认更换企业弹窗-->
    <el-dialog
      title="请选择职位、简历的交接对象："
      :visible.sync="dialogCompanyChangeVisible"
      class="dialog-option-mod"
      width="500px"
    >
      <span>
        <div class="infoDialogCompanyQrTitle">
          若无人员可选，请先邀请对方注册成为地产同行圈的招聘者
        </div>
        <el-select v-model="value" placeholder="请选择" style="width: 100%">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </span>

      <span
        slot="footer"
        class="dialog-footer"
        style="width: 100%; position: relative; display: inline-block"
      >
        <span
          @click="quit()"
          style="
            position: absolute;
            left: 0;
            line-height: 40px;
            cursor: pointer;
            color: #4061f8;
          "
          >无需交接，直接退出</span
        >
        <el-button @click="dialogCompanyChangeVisible = false">取 消</el-button>
        <el-button @click="changCompanyQue" type="primary"
          >交接并退出</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title
      :visible.sync="dialogCompanyChangeVisibleJD"
      class="adminDialog"
    >
      <div
        style="
          display: flex;
          width: 80%;
          margin: auto;
          line-height: 46px;
          padding: 0 40px 20px;
        "
      >
        <span style="height: 46px; width: 46px; margin-right: 10px">
          <i class="el-icon-loading"></i>
        </span>

        <!--        <img :src="require('$img/company.png')" height="46px" width="46px" />-->
        <div>正在处理中，请勿关闭页面..</div>
      </div>
    </el-dialog>

    <!--        确认直接退出-->
    <el-dialog
      title="确认退出"
      :visible.sync="dialogQuitVisible"
      class="adminDialog"
    >
      <div class="infoDialogTitle">
        直接退出后，您在当前企业所关联的所有职位、简历、权益等将一并失效，确认要退出吗？
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogQuitVisible = false">取消</el-button>
        <el-button type="primary" @click="changQuit">确认退出</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { mapActions, mapMutations, mapState } from "vuex";
import enterpriseInfo from "../../components/InfoComponent/enterpriseInfo";
import account from "./account";

const validatePhoneNumber = (rule, value, callback) => {
  if (!/^(((\d{3,4}-)?[0-9]{7,8})|(1\d{10}))$/.test(value)) {
    callback(new Error("请填写正确的招聘电话"));
  }
  callback();
};
const validateWechat = (rule, value, callback) => {
  if (
    !/^[a-zA-Z][a-zA-Z0-9_-]{5,19}$/.test(value) &&
    !/^(((\d{3,4}-)?[0-9]{7,8})|(1\d{10}))$/.test(value)
  ) {
    callback(new Error("请填写正确的招聘微信"));
  }
  callback();
};
const validateMail = (rule, value, callback) => {
  if (
    value &&
    !/(?=^.{3,256}$)^([\w\-]+([\.][\w\-]+)*)@[a-zA-Z0-9][a-zA-Z0-9\-]*[\.][A-Za-z]{2,6}$/.test(
      value
    )
  ) {
    callback(new Error("请填写正确的招聘邮箱"));
  }
  callback();
};

export default {
  components: {
    enterpriseInfo,
    account,
  },
  data() {
    return {
      activeName: "first",
      dialogFormVisible: false,
      dialogImgVisible: false,
      dialogCompanyVisible: false,
      dialogCompanyChangeVisible: false,
      dialogQuitVisible: false,
      formLabelWidth: "100px",
      defaultEmail: "",
      defaultPhone: "",
      defaultWechat: "",
      form: {
        recruit_phone: "",
        recruit_wechat: "",
        recruit_mail: "",
      },
      radio: 1,
      index: false,
      userInfo: {},
      options: [],
      value: null,
      dialogCompanyChangeVisibleJD: false,
      rules: {
        recruit_phone: [
          {
            required: true,
            message: "请填写正确的招聘电话",
            trigger: "change",
          },
          { validator: validatePhoneNumber, trigger: "change" },
        ],
        recruit_wechat: [
          {
            required: true,
            message: "请填写正确的招聘微信",
            trigger: "change",
          },
          { validator: validateWechat, trigger: "change" },
        ],
        recruit_mail: [
          {
            required: false,
            message: "请填写正确的招聘邮箱",
            trigger: "change",
          },
          { validator: validateMail, trigger: "change" },
        ],
      },
      telStatus: false,
      weChatStatus: false,
      mailStatus: false,
      loading: false,
      adminDialogType: false,
      choseName: "",
      ruleForm: {
        oldpass: "",
        newpass: "",
        cpass: "",
      },
      submitLoading: false,
      pawwrules: {
        oldpass: [
          // {
          //   required: true,
          //   message: "请填写正确的旧密码（6~16位）",
          //   trigger: "blur",
          // },
          {
            min: 6,
            max: 16,
            message: "请填写正确的旧密码（6~16位）",
            trigger: "blur",
          },
        ],
        newpass: [
          {
            required: true,
            message: "请填写正确的新密码（6~16位）",
            trigger: "blur",
          },
          {
            min: 6,
            max: 16,
            message: "请填写正确的新密码（6~16位）",
            trigger: "blur",
          },
        ],
        cpass: [
          {
            required: true,
            message: "请填写正确的确认密码（6~16位）",
            trigger: "blur",
          },
          {
            min: 6,
            max: 16,
            message: "请填写正确的确认密码（6~16位）",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.adminDialogType = true;
    if (this.$route.query.value == 2) {
      this.activeName = "second";
    }
    this.init();
  },
  computed: {
    httpUrl() {
      return process.env.VUE_APP_API_URL;
    },
    headerStr() {
      return {
        token: Cookies.get("pc_token") || "",
        version: process.env.VUE_APP_VERSION,
      };
    },
  },
  methods: {
    ...mapMutations(["SAVA_USER_INFO"]),
    ...mapActions(["userInfoUpdate"]),
    init() {
      this.$axios
        .post("/recruitment/user/userInfo", {})
        .then((res) => {
          this.userInfo = res.data;
          this.form = res.data;
          this.defaultEmail = res.data.recruit_mail;
          this.defaultPhone = res.data.recruit_phone;
          this.defaultWechat = res.data.recruit_wechat;
          this.SAVA_USER_INFO(res.data);
          if (this.userInfo.recruit_name_show == this.userInfo.recruit_name) {
            this.radio = 1;
            this.choseRadio(
              1,
              this.userInfo.gender,
              this.userInfo.recruit_name
            );
          } else {
            this.radio = 2;
            this.choseRadio(
              2,
              this.userInfo.gender,
              this.userInfo.recruit_name
            );
          }
          this.userInfo.recruit_mail_show == 1
            ? (this.mailStatus = true)
            : (this.mailStatus = false);
          this.userInfo.recruit_phone_show == 1
            ? (this.telStatus = true)
            : (this.telStatus = false);
          this.userInfo.recruit_wechat_show == 1
            ? (this.weChatStatus = true)
            : (this.weChatStatus = false);
        })
        .finally(() => {
          this.adminDialogType = false;
        });
    },
    editUserInfo() {
      this.dialogFormVisible = true;
      // this.adminDialogType=true;
      // this.init();
    },
    replaceMobile(tel) {
      // replace()方法在字符串中用一些字符替换另一些字符，或替换一个与正则表达式匹配的子串。
      let tel1 = tel.replace(tel.substring(3, 7), "****");
      return tel1;
    },
    beforeAvatarUpload(file) {
      this.dialogImgVisible = false;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!["image/jpeg", "image/jpge", "image/png"].includes(file.type)) {
        this.$message.error("上传头像图片只能是 JPG、JPGE、PNG格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
        return false;
      }
      this.loading = true;
    },
    updateSuccess(res) {
      this.userInfo.head_logo = res.data.file.url;
      this.dialogImgVisible = false;
      this.$axios
        .post("/recruitment/user/saveInfo", {
          head_logo: this.userInfo.head_logo,
        })
        .then((res) => {
          console.log(res);
          this.dialogFormVisible = false;
          this.loading = false;
          this.$refs.upload.clearFiles();
          this.$message.success("保存成功!");
          this.init();
        })
        .finally(() => {});
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    editor(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.telStatus && !this.weChatStatus && !this.mailStatus) {
            //若3个勾选框都没选中
            this.$message.warning(
              "至少要保留一种联系方式，便于求职者能够联系您!"
            );
          } else if (this.mailStatus && !this.form.recruit_mail) {
            //若只有邮箱对应勾选框被选中，且招聘邮箱为空
            this.$message.warning("需要填写招聘邮箱后才能显示哦!");
          } else {
            this.$axios
              .post("/recruitment/user/saveInfo", {
                recruit_name_show: this.choseName,
                recruit_phone: this.form.recruit_phone,
                recruit_mail: this.form.recruit_mail,
                recruit_wechat: this.form.recruit_wechat,
                recruit_phone_show: this.telStatus ? 1 : 0,
                recruit_wechat_show: this.weChatStatus ? 1 : 0,
                recruit_mail_show: this.mailStatus ? 1 : 0,
              })
              .then((res) => {
                console.log(res);
                this.dialogFormVisible = false;
                this.loading = false;
                this.$message.success("保存成功!");
                this.init();
              })
              .finally(() => {});
          }
        } else {
          this.$message({
            type: "error",
            message: "验证失败，请重新填写",
          });
          return false;
        }
      });
    },
    changCompany() {
      this.dialogCompanyVisible = false;
      this.dialogCompanyChangeVisible = true;
    },
    changCompanyQue() {
      if (this.value) {
        this.dialogCompanyVisible = false;
        this.dialogCompanyChangeVisible = false;
        this.dialogCompanyChangeVisibleJD = true;
        let _this = this;
        _this.$axios
          .post("/recruitment/user/userChangeCompany", {
            id: _this.value,
          })
          .then(() => {
            this.userInfoUpdate().then(() => {
              _this.dialogCompanyChangeVisibleJD = false;
              this.$router.push("/certification");
            });
          })
          .finally(() => {});
      } else {
        this.$message({
          type: "error",
          message: "提交失败，请选择交接人",
        });
      }
    },
    choseRadio(type, gender, recruit_name_show) {
      this.radio = type;
      if (this.radio == 1) {
        this.choseName = recruit_name_show;
      } else {
        if (gender == 0) {
          this.choseName = recruit_name_show.slice(0, 1) + "女士";
        } else {
          this.choseName = recruit_name_show.slice(0, 1) + "先生";
        }
      }
    },
    bindCompany() {
      this.dialogCompanyVisible = true;
      this.$axios
        .post("/recruitment/companyUser", {})
        .then((res) => {
          this.options = res.data.users.map((item) => ({
            label: item.name + this.replaceMobile(item.mobile),
            value: item.id,
          }));
          this.options.unshift({
            value: null,
            label: "请选择",
          });
        })
        .finally(() => {});
    },
    submitForm(formName) {
      this.submitLoading = true;

      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.newpass !== this.ruleForm.cpass) {
            this.submitLoading = false;
            this.$message.error("两次输入的新密码不一致");
            return;
          }
          this.$axios
            .post("/recruitment/auth/modifypwd", {
              oldpassword: this.ruleForm.oldpass,
              password: this.ruleForm.newpass,
            })
            .then(() => {
              this.$success("修改密码成功");

              this.ruleForm = {
                oldpass: "",
                newpass: "",
                cpass: "",
              };
            })
            .catch((err) => {
              // this.$fail(err.msg || err)
            })
            .finally(() => {
              this.submitLoading = false;
            });
        } else {
          this.submitLoading = false;
          return false;
        }
      });
    },
    quit() {
      this.dialogQuitVisible = true;
    },
    changQuit() {
      this.dialogCompanyChangeVisibleJD = true;
      this.dialogQuitVisible = false;

      this.$axios
        .post("/recruitment/user/unbindCompany", this.ruleForm)
        .then(() => {
          this.userInfoUpdate().then(() => {
            this.$success("您已退出当前企业");
            this.dialogCompanyChangeVisibleJD = false;
            this.dialogCompanyChangeVisible = false;
            this.$router.push("/certification");
          });
        })
        .catch((err) => {
          // this.$fail(err.msg || err)
        });
    },
  },
};
</script>

<style lang="scss">
.info {
  height: 100%;
  background: #f9fafb;
  .el-tabs {
    background: #f9fafb;
    padding: 10px 0;
    height: calc(100% - 5px);
    .el-tabs__content{
      height: 94%;
      overflow:auto;
    }
   .tabs-b{
      background: #ffffff;
      padding: 20px 20px;
   }
    .el-tabs__header {
      background: #ffffff;
      border-radius: 4px;
      height: 56px;
      line-height: 56px;
      border: none;
      margin-bottom: 10px;
      .el-tabs__item {
        border: none;
        font-size: 16px;
        font-weight: 500;
        color: #3c4554;
      }
      .is-active{
        color: #4061F8;
      }
      .el-tabs__nav {
        border: none;
      }
    }
  }
  .infoContent .el-form-item {
    margin-bottom: 21px;
  }
  .infoContent {
    // padding: 2% 3%;
    // padding: 20px 0;
    // background: #f9fafb;
    height: 100%;
    overflow: auto;
    .infoContent-title {
      font-size: 20px;
      color: #3c4554;
      font-weight: bold;
      display: flex;
      justify-content: flex-start;

      .edit-icon {
        font-weight: 500;
        font-size: 20px;
        color: #4061f8;
      }

      .edit-txt {
        display: inline-block;
        font-size: 16px;
      }

      .el-icon-edit {
        color: #4061f8;
        margin-left: 23px;
        cursor: pointer;
        margin-right: 4px;
      }
    }
    .infoContent-image {
      width: 105px;
      height: 105px;
      cursor: pointer;
      border: 1px solid #cfd7e1;
      margin: 20px 0 30px;
      position: relative;
      border-radius: 50%;
      overflow: hidden;
      .infoContent-image-div {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 9999;
        background: red;
        top: 0;
        opacity: 0;
      }
      .infoContent-image-span {
        position: absolute;
        bottom: 0px;
        left: 0px;
        color: #fff;
        font-size: 14px;
        text-align: center;
        line-height: 30px;
        background: #4061f8;
        z-index: 1111;
        width: 100%;
        height: 30px;
      }
    }
    .infoContent-tel {
      border-top: 1px solid #eeeeee;
      border-bottom: 1px solid #eeeeee;
      padding: 20px 0;
      margin: 20px 0;
      .infoContent-tel-mes {
        font-size: 14px;
        color: #606266;
      }
    }
    .companyEdit {
      div {
        font-size: 16px;
        font-weight: bold;
      }
      .el-icon-edit {
        color: #4061f8;
        font-size: 18px;
        cursor: pointer;
      }

      img {
        cursor: pointer;
      }

      .jb-txt {
        color: #4061f8;
        font-size: 14px;
        font-weight: 500;
        line-height: 26px;
        cursor: pointer;
      }
    }
    .companyMes {
      line-height: 46px;
      span {
        margin-left: 22px;
        font-size: 14px;
        color: #606266;
      }
    }
    .adminList {
      display: flex;
      margin-bottom: 20px;
      font-size: 14px;
      color: #3c4554;
      div {
        color: #606266;
        width: 80px;
      }
    }
  }

  .dialog-option-mod {
    // max-width: 500px;
    .infoDialogCompanyQrTitle {
      font-size: 16px;
      color: #3c4554;
      margin-bottom: 20px;
    }
  }

  .adminDialog {
    z-index: 2222 !important;
    .el-dialog {
      max-width: 500px;
      width: 90% !important;
    }
    .el-dialog__title {
      color: #000;
      font-weight: bold;
    }
    .el-button--primary {
      background-color: #4061f8;
      border-color: #4061f8;
    }
    .el-form-item__label {
      color: #606266;
    }
    .el-radio__input.is-checked .el-radio__inner {
      border-color: #4061f8;
      background: #4061f8;
    }
    .el-radio__input.is-checked + .el-radio__label {
      color: #4061f8;
    }
    .infoRadion {
      display: flex;
      div {
        padding: 12px;
        width: 110px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        cursor: pointer;
      }
      div:first-child {
        margin-right: 10px;
      }
      .infoRadionActive {
        border: 1px solid #4061f8 !important;
      }
    }
    .infoDialogTitle {
      font-size: 16px;
      color: #606266;
    }
    .infoDialogCompanyFirst {
      font-size: 16px;
      color: #3c4554;
      margin-bottom: 20px;
    }
    .infoDialogCompany {
      font-size: 14px;
      color: #606266;
      margin-bottom: 20px;
    }
    .infoDialogCompanyQrTitle {
      font-size: 16px;
      color: #3c4554;
      margin-bottom: 20px;
    }
    .avatar-uploader {
      position: absolute;
      right: 20px;
      bottom: 20px;
      .el-upload {
        height: 40px;
        width: 98px;
        img {
          width: 0;
          height: 0;
        }
      }
    }
    .adminInput {
      width: 80%;
      margin-right: 10px;
    }
    .adminCheck {
      .el-checkbox__label {
        padding-left: 5px;
      }
    }
  }
  .el-icon-loading:before {
    font-size: 40px;
  }
}
</style>
